"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function ($location) {
  return {
    url: $location.url(),
    path: $location.path(),
    params: _extends({}, $location.search()),
    hash: $location.hash(),
    state: $location.state()
  };
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/ng-redux-route/lib/router.js
// module id = 419
// module chunks = 0